import React from 'react';

import styles from './AvailableAppointments.css';
import Results from './Results';
import SearchForm from './SearchForm';

const AvailableAppointments = ({  
  customers,
  detailEnabled,
  dropdowns,
  form,
  appointments,
  loading,  
  onCustomerSearch,
  onBidClick,
  onFormUpdate,
  onDatasheetSearchChange,
  datasheetsearch
}) => {
  
  var updatedappointments = appointments.map((b) => {
    if(b.officeName)
    { return {...b, eventtype:'datasheet' } }
    else
    { return {...b, eventtype:'customer' } }
  });

  updatedappointments.sort(function(a, b){return b.id - a.id});


  return (
  <div className={styles.container}>
    <SearchForm
      customers={customers}
      dropdowns={dropdowns}
      form={form}
      loading={loading}
      onCustomerSearch={onCustomerSearch}
      onFormUpdate={onFormUpdate}
      datasheetsearch={datasheetsearch}
      onDatasheetSearchChange={onDatasheetSearchChange}
    />
    <Results      
      appointments={updatedappointments}
      className={styles.results}     
      loading={loading}           
    />
  </div>
)};

export default AvailableAppointments;
